import { render, staticRenderFns } from "./PortalNavigations.vue?vue&type=template&id=5a4b14df"
import script from "./PortalNavigations.vue?vue&type=script&lang=js"
export * from "./PortalNavigations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports